














































































import Interval from '@/components/Common/Interval'
import { Col, Row, Button } from 'element-ui'
import { WRTCServer, WRTCServerType } from '@/types/admin'
import './WRTCServerSummary.scss'
import { StatusColor } from '.'
import { computed, defineComponent } from '@vue/composition-api'
import useWrtcStats from '../../../compositions/wrtcStats'
import useDecomposedWRTCServer from '../../../compositions/decomposedWRTCServer'
import useWrtcStatsToString from '../../../compositions/wowzaStatsToString'


export default defineComponent({
  name: 'WRTCServerSummary',
  components: {
    'el-col': Col,
    'el-row': Row,
    'el-button': Button,
    Interval
  },
  props: {
    server: {
      type: Object as () => WRTCServer,
      required: true
    },
    serverid: {
      type: String,
      required: true
    },
    deleteButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup (props) {
    const wowzaStats = useWrtcStats().wrtcStats
    const stats = computed(() => wowzaStats.value[props.serverid])
    return {
      wowzaStats,
      stats,
      ...useDecomposedWRTCServer(props.server),
      ...useWrtcStatsToString(stats)
    }
  },
  data: () => ({
    now: 0,
    collapsed: true
  }),
  computed: {
    serverUptime (): string {
      if (this.stats === undefined) return 'unknown'
      if (this.stats.serverType === WRTCServerType.JANUS) return 'unknown'
      return this.secondsToTime(this.stats.serverUptime)
    },
    lastUpdated (): string {
      if (this.stats === undefined) return 'unknown'
      const seconds = this.now - this.stats.lastUpdate.seconds
      if (seconds > 300) return 'offline'
      return `${seconds} s ago`
    },
    lastUpdatedColor (): StatusColor {
      if (this.stats === undefined) return StatusColor.GRAY
      return this.lastUpdated === 'offline' ? StatusColor.RED : StatusColor.GREEN
    },
    summaryColor (): StatusColor {
      const colors = [this.lastUpdatedColor, this.diskColor, this.heapColor, this.memoryColor,
                      this.cpuColor, this.threadsColor, this.connectionColor]
      if (colors.every((color) => color === StatusColor.GRAY)) return StatusColor.GRAY
      return (colors.includes(StatusColor.RED)) ? StatusColor.RED : StatusColor.GREEN
    }
  },
  methods: {
    secondsToTime (seconds: number): string {
      const days = Math.floor(seconds / (24 * 3600))
      const hours = Math.floor((seconds - days * 3600 * 24) / 3600)
      const minutes = Math.floor((seconds - (days * 3600 * 24) - hours * 3600) / 60)
      return `${days}d ${hours}h ${minutes}m`
    },
    deleteServer () {
      this.$confirm('Are you sure you want to delete this server from the region?', 'Delete Wowza Server').then(() => {
        this.$store.direct.dispatch.admin.deleteWowzaServer(this.serverid).catch((error) => {
          this.$message('Could not delete wowza server ' + error.message)
        })
      }).catch(() => {})
    },
    disableServer () {
      const action = this.enabled ? 'disable' : 'enable'
      const message = `Are you sure you want to ${action} this server from the region?`
      this.$confirm(message, `${action} Wowza Server`).then(() => {
        this.$store.direct.dispatch.admin.enableWowzaServer({
          serverId: this.serverid,
          enabled: !this.enabled
        }).catch((error) => {
          this.$message('Could not disable/enable wowza server ' + error.message)
        })
      }).catch(() => {})
    },
    clockUpdate () {
      this.now = Date.now() / 1000
    }
  }
})
